export default "__VITE_ASSET__CPXeWMH5__"